/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Table_Overwrite_Success_ToastInputs */

const en_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project "${i?.name}" overwritten successfully`)
};

const fr_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projet "${i?.name}" ecrase avec succes`)
};

const de_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projekt "${i?.name}" erfolgreich überschrieben`)
};

const it_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progetto "${i?.name}" sovrascritto con successo`)
};

const ru_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Проект "${i?.name}" успешно перезаписан.`)
};

const es_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El proyecto "${i?.name}" se sobrescribió correctamente`)
};

const zh_cn2_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目“${i?.name}”已成功覆盖`)
};

const ja_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクト「${i?.name}」が正常に上書きされました`)
};

const hi_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट "${i?.name}" सफलतापूर्वक ओवरराइट हो गया`)
};

const pt_pt2_explorer_table_overwrite_success_toast = /** @type {(inputs: Explorer_Table_Overwrite_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O projeto "${i?.name}" foi sobrescrito com sucesso.`)
};

/**
* | output |
* | --- |
* | "Project \"{name}\" overwritten successfully" |
*
* @param {Explorer_Table_Overwrite_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_overwrite_success_toast = /** @type {((inputs: Explorer_Table_Overwrite_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Overwrite_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_overwrite_success_toast(inputs)
	if (locale === "de") return de_explorer_table_overwrite_success_toast(inputs)
	if (locale === "it") return it_explorer_table_overwrite_success_toast(inputs)
	if (locale === "ru") return ru_explorer_table_overwrite_success_toast(inputs)
	if (locale === "es") return es_explorer_table_overwrite_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_overwrite_success_toast(inputs)
	if (locale === "ja") return ja_explorer_table_overwrite_success_toast(inputs)
	if (locale === "hi") return hi_explorer_table_overwrite_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_overwrite_success_toast(inputs)
	return en_explorer_table_overwrite_success_toast(inputs)
});